"use client"

import { ScopeProvider } from "bunshi/react"
import { ProfileScope, type ScopeState } from "."

interface Props {
  children: React.ReactNode
  state: ScopeState
}

export function ProfileScopeProvider({ children, state }: Props) {
  return (
    <ScopeProvider scope={ProfileScope} value={state}>
      {children}
    </ScopeProvider>
  )
}
